import BaseService from "service/base.js";

class ContentFolderService {
  load() {
    return BaseService.get("/api/content-folders");
  }

  new(name, items) {
    return BaseService.post("/api/content-folders", { name, items });
  }

  move(folderId, items) {
    return BaseService.put("/api/content-folder/move", {
      items,
      folder_id: folderId,
    });
  }
}

const contentFolderService = new ContentFolderService();
export { contentFolderService };
